import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Router
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import ErrorPage from "./routes/ErrorPage";
import Financing from './routes/Financing';
import Ordering from './routes/Ordering';
import Product from './routes/Product';
import Home from './routes/Home';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        errorElement: <ErrorPage />,
        children: [
          { index: true, element: <Home /> },
          {
            path: "products",
            element: <Product />
          },
          {
            path: "financing",
            element: <Financing />
          },
          {
            path: "ordering",
            element: <Ordering />
          },
          {
            path: "*",
            element: <ErrorPage />
          }
        ]
      }
    ]
  }
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider
      router={router}
    />
  </React.StrictMode>
);
